/**
 * 選択したメディア情報からタグとメモの有無をチェックするカスタムフック
 * 写真一覧画面の場合は、選択したタイムライン情報からタグとメモの有無をチェックする
 * 写真詳細画面の場合は、mediaInfoからタグとメモの有無をチェックする
 *
 * @param {*} timelines
 * @param {*} checkbox
 * @param {*} selectedMediaInfo
 * @param {*} isMediaPage
 * @returns {Object}
 */
const useCheckDeleteTagsAndMemo = (
  timelines,
  checkbox,
  selectedMediaInfo,
  isMediaPage,
) => {
  if (isMediaPage) {
    const filteredTimelines = timelines.filter(timeline =>
      checkbox.ids.includes(timeline.id),
    );

    const hasMemo = filteredTimelines.every(
      timeline => timeline.freeTag !== null,
    );
    const hasTags = filteredTimelines.every(
      timeline => timeline.tags.length > 0,
    );
    return { hasMemo, hasTags };
  }

  const hasMemo = selectedMediaInfo.freeTag !== null;
  const hasTags = selectedMediaInfo.tags.some(
    tag => Object.keys(tag).length > 0,
  );
  return { hasMemo, hasTags };
};

export default useCheckDeleteTagsAndMemo;
